import React from 'react';

/**
 * Plain text of an option label, for `title` tooltips on the custom select
 * triggers and options. Strings and numbers are concatenated depth-first;
 * elements contribute their children.
 */
export function getNodeText(node: React.ReactNode): string {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(getNodeText).join('');
  if (React.isValidElement<{ children?: React.ReactNode }>(node)) {
    return getNodeText(node.props.children);
  }
  return '';
}

/**
 * Tooltip text of an `<option>`: its explicit `title` when given (rich options
 * whose children would concatenate without separators), else its text.
 * Undefined when empty so no blank tooltip is rendered.
 */
export function getOptionTitle(title: unknown, children: React.ReactNode): string | undefined {
  const explicit = typeof title === 'string' ? title.trim() : '';
  const text = explicit || getNodeText(children).replace(/\s+/g, ' ').trim();
  return text.length > 0 ? text : undefined;
}
